document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('pricing-info-modal');
  if (!modal) return;

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-pricing-info-trigger');
    if (trigger) {
      e.preventDefault();
      modal.open(trigger);
    }
  });
});
